import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            dark: {
                primary: '#5d7d9a',
                secondary: '#5d7d9a',
                violet:'#7c62dd'
            },
            light: {
                primary: '#5d7d9a',
                secondary: '#5d7d9a',
                violet:'#7c62dd'
            },
        },
    },
})
